import { Component } from 'react';
import classNames from 'classnames';
import { PropertyExplorerSection as theme } from 'legacy/css-modules';

export default class PropertyExplorerSection extends Component {
  render() {
    const { children, printPageBreak, dataHcName, className } = this.props;
    return (
      <section
        className={classNames(theme.PropertyExplorerSection, className, {
          'property-explorer-print-pagebreak': printPageBreak
        })}
        data-hc-name={dataHcName}
      >
        {children}
      </section>
    );
  }
}
